import { QueryKeys } from '@frontend/features/common/types';

export const connectorCapabilitiesQueryKey = (agencyId: number) =>
  [QueryKeys.getRuteroCatalog, 'connectors', agencyId] as const;

export const connectorCapabilitiesQueryOptions = (agencyId: number) => ({
  queryKey: connectorCapabilitiesQueryKey(agencyId),
  staleTime: 30 * 60 * 1000,
  retry: false,
  refetchOnWindowFocus: 'always' as const,
  refetchOnMount: 'always' as const,
});

export const connectorCapabilitiesAreActionable = ({
  isSuccess,
  isFetching,
}: {
  isSuccess: boolean;
  isFetching: boolean;
}) => isSuccess && !isFetching;
